var Login = function(){

	var comp = $('[data-component="login-block"]');

	this.init = function(){

		$('#login').validate({
			ignore: '.ignore',
			errorPlacement: function() {
				return true;
			},
			rules: {
				mail: {
					required: true,
					email: true
				},
				password: {
					required: true
				}
			},
			submitHandler: function(form) {
				// form.submit();
			}
		});

	}

	return this.init();

}
